import { render, staticRenderFns } from "./SingleSourceContent.vue?vue&type=template&id=1bb40e34&scoped=true"
import script from "./SingleSourceContent.vue?vue&type=script&lang=js"
export * from "./SingleSourceContent.vue?vue&type=script&lang=js"
import style0 from "./SingleSourceContent.vue?vue&type=style&index=0&id=1bb40e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb40e34",
  null
  
)

export default component.exports